module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n    " + _vm._s(_vm.actionToBePerformed) + "\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/reengagement-manager/view"
    }
  }, [_vm._v("Back")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.actionToBePerformed))])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12"
  }, [_c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createOrUpdateReengagement.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduleData.name),
      expression: "scheduleData.name"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.scheduleData.name.required
    },
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "id": "opportunity_name",
      "placeholder": "Reengagement Name"
    },
    domProps: {
      "value": (_vm.scheduleData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scheduleData, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.scheduleData.name.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please provide a reengagement name.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.scheduleData.type.required
    },
    attrs: {
      "disabled": "",
      "id": "Client"
    },
    model: {
      value: (_vm.scheduleData.type),
      callback: function($$v) {
        _vm.$set(_vm.scheduleData, "type", $$v)
      },
      expression: "scheduleData.type"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select a reengagement type--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "one-time batch"
    }
  }, [_vm._v("one-time batch")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "automated trigger"
    }
  }, [_vm._v("automated trigger")])]), _vm._v(" "), (_vm.submitted && !_vm.$v.scheduleData.type.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a reengagement type.")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Country")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.scheduleData.country.required
    },
    on: {
      "change": function($event) {
        return _vm.handleCountryChange()
      }
    },
    model: {
      value: (_vm.scheduleData.country),
      callback: function($$v) {
        _vm.$set(_vm.scheduleData, "country", $$v)
      },
      expression: "scheduleData.country"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a country--")]), _vm._v(" "), _vm._l((_vm.countryList), function(value, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": value.country_id
      }
    }, [_vm._v(_vm._s(value.country_name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.scheduleData.country.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a country.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "checkbox-inline",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduleData.isNewUserBatch),
      expression: "scheduleData.isNewUserBatch"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.scheduleData.isNewUserBatch) ? _vm._i(_vm.scheduleData.isNewUserBatch, null) > -1 : (_vm.scheduleData.isNewUserBatch)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.scheduleData.isNewUserBatch,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.scheduleData, "isNewUserBatch", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.scheduleData, "isNewUserBatch", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.scheduleData, "isNewUserBatch", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v("is New User Batch")]), _vm._v(" "), _vm._m(2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "audience"
    }
  }, [_vm._v("Audience")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.scheduleData.audience.required
    },
    attrs: {
      "id": "audience"
    },
    model: {
      value: (_vm.scheduleData.audience),
      callback: function($$v) {
        _vm.$set(_vm.scheduleData, "audience", $$v)
      },
      expression: "scheduleData.audience"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose an audience--")]), _vm._v(" "), _vm._l((_vm.audienceList), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": data.id
      }
    }, [_vm._v(_vm._s(data.query_name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.scheduleData.audience.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose an audience.")]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Step 3 | Message & Details\n                      "), (_vm.turnCountry) ? _c('small', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Nudge templates from "), _c('b', [_vm._v(_vm._s(_vm.turnCountry))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, _vm._l((_vm.splitOptions), function(splitOptn) {
    return _c('div', {
      key: splitOptn.value
    }, [_c('label', {
      staticClass: "radio-inline col-xs-4 col-sm-4 col-md-2 col-lg-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.split_type),
        expression: "split_type"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": splitOptn.value,
        "checked": _vm._q(_vm.split_type, splitOptn.value)
      },
      on: {
        "change": [function($event) {
          _vm.split_type = splitOptn.value
        }, _vm.onSplitTypeChange]
      }
    }), _vm._v(_vm._s(splitOptn.label) + "\n                            ")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-rounded btn-nudge",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" Add New Group\n                        ")])])])]), _vm._v(" "), _vm._l((_vm.groupList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "panel panel-default panel-group-container"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('h3', {
      staticClass: "panel-title group-title"
    }, [_vm._v("Group " + _vm._s(index + 1) + "\n                              "), _c('div', {
      staticClass: "remove-group-btn-container"
    }, [_c('button', {
      staticClass: "btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2",
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("\n                                Remove Group\n\n                            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 col-lg-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
    }, [_c('label', [_vm._v("Nudge")]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "col-xs-6 col-sm-6 col-md-6",
      staticStyle: {
        "padding-left": "0px"
      }
    }, [_c('treeselect', {
      class: {
        'form-group--error': _vm.submitted && !_vm.$v.groupList.$each[index].msg_template_id.required
      },
      attrs: {
        "placeholder": "--Choose a nudge--",
        "multiple": false,
        "options": _vm.nudgesList
      },
      model: {
        value: (item.msg_template_id),
        callback: function($$v) {
          _vm.$set(item, "msg_template_id", $$v)
        },
        expression: "item.msg_template_id"
      }
    }), _vm._v(" "), (_vm.submitted && !_vm.$v.groupList.$each[index].msg_template_id.required) ? _c('span', {
      staticClass: "text-red pull-right"
    }, [_vm._v("Please choose a nudge.")]) : _vm._e()], 1), _vm._v(" "), (item.msg_template_id) ? _c('div', {
      staticClass: "col-xs-6 col-sm-6 col-md-6",
      staticStyle: {
        "padding": "0px",
        "margin-left": "-15px"
      }
    }, [_c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.onNudgePreviewClick(item.msg_template_id)
        }
      }
    }, [_vm._v("Preview")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 col-lg-12 col-xs-12 keyword-conversation-container"
    }, [_c('div', {
      staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
    }, [_c('label', [_vm._v("Keyword")]), _vm._v(" "), _c('treeselect', {
      class: {
        'form-group--error': _vm.submitted && !_vm.$v.groupList.$each[index].keyword_id.required
      },
      attrs: {
        "placeholder": "--Choose a keyword--",
        "multiple": false,
        "disabled": !!item.conversation_id,
        "options": _vm.keywordsList
      },
      model: {
        value: (item.keyword_id),
        callback: function($$v) {
          _vm.$set(item, "keyword_id", $$v)
        },
        expression: "item.keyword_id"
      }
    }), _vm._v(" "), (_vm.submitted && !_vm.$v.groupList.$each[index].keyword_id.required) ? _c('span', {
      staticClass: "text-red pull-right"
    }, [_vm._v("Please choose a keyword.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "or-container col-xs-1 col-sm-1 col-md-1"
    }, [_vm._v("OR")]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-5 col-sm-5 col-md-5"
    }, [_c('label', [_vm._v("Conversation OR Journey")]), _vm._v(" "), _c('treeselect', {
      class: {
        'form-group--error': _vm.submitted && !_vm.$v.groupList.$each[index].conversation_id.required
      },
      attrs: {
        "placeholder": "--Choose a conversation--",
        "disabled": !!item.keyword_id,
        "multiple": false,
        "options": _vm.conversationList
      },
      model: {
        value: (item.conversation_id),
        callback: function($$v) {
          _vm.$set(item, "conversation_id", $$v)
        },
        expression: "item.conversation_id"
      }
    }), _vm._v(" "), (_vm.submitted && !_vm.$v.groupList.$each[index].conversation_id.required) ? _c('span', {
      staticClass: "text-red pull-right"
    }, [_vm._v("Please choose a conversation.")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 col-lg-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
    }, [_c('label', [_vm._v("Destination")]), _vm._v(" "), _c('treeselect', {
      class: {
        'form-group--error': _vm.submitted && !_vm.$v.groupList.$each[index].destination_app_name.required
      },
      attrs: {
        "placeholder": "--Choose a conversation--",
        "multiple": false,
        "options": _vm.destinationList
      },
      model: {
        value: (item.destination_app_name),
        callback: function($$v) {
          _vm.$set(item, "destination_app_name", $$v)
        },
        expression: "item.destination_app_name"
      }
    }), _vm._v(" "), (_vm.submitted && !_vm.$v.groupList.$each[index].destination_app_name.required) ? _c('span', {
      staticClass: "text-red pull-right"
    }, [_vm._v("Please choose a conversation.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "or-container col-xs-1 col-sm-1 col-md-1"
    }), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-5 col-sm-5 col-md-5"
    }, [_c('label', [_vm._v("Split (%)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.split_percent),
        expression: "item.split_percent"
      }],
      staticClass: "form-control",
      class: {
        'form-group--error': _vm.submitted && (!_vm.$v.groupList.$each[index].split_percent.required || !_vm.$v.groupList.$each[index].split_percent.minValue || !_vm.$v.groupList.$each[index].split_percent.maxValue || !_vm.$v.groupList.$each[index].split_percent.numeric)
      },
      attrs: {
        "type": "text",
        "disabled": _vm.split_type === 'EQUAL',
        "autocomplete": "off",
        "id": "opportunity_name",
        "placeholder": "Split Percentage out of 100"
      },
      domProps: {
        "value": (item.split_percent)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "split_percent", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.submitted && !_vm.$v.groupList.$each[index].split_percent.required) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please enter split percentage.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && (!_vm.$v.groupList.$each[index].split_percent.minValue || !_vm.$v.groupList.$each[index].split_percent.maxValue)) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please enter number between 1 to 100.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && !_vm.$v.groupList.$each[index].split_percent.numeric) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please enter valid integer value.")]) : _vm._e()])])])])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6 col-lg-6 col-xs-6"
  }, [_c('label', [_vm._v("Select Deployment Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduleData.deploymentDate),
      expression: "scheduleData.deploymentDate"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.scheduleData.deploymentDate.required
    },
    attrs: {
      "min": _vm.getDate(),
      "type": "date"
    },
    domProps: {
      "value": (_vm.scheduleData.deploymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scheduleData, "deploymentDate", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.scheduleData.deploymentDate.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a deployment date.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-lg-6 col-sm-6 col-md-6"
  }, [_c('label', [_vm._v("Select Deployment Time")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduleData.deploymentTime),
      expression: "scheduleData.deploymentTime"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.scheduleData.deploymentTime.required
    },
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.scheduleData.deploymentTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scheduleData, "deploymentTime", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.scheduleData.deploymentTime.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a deployment date.")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "action-button"
  }, [_c('input', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "submit",
      "value": "SAVE AS DRAFT"
    },
    on: {
      "click": function($event) {
        return _vm.setReengagementAction(true)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "submit",
      "value": "SAVE & SCHEDULE"
    },
    on: {
      "click": function($event) {
        return _vm.setReengagementAction(false)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "button",
      "value": "CANCEL"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm()
      }
    }
  })])])])])])])])])]), _vm._v(" "), (_vm.showNudgePreview) ? _c('div', {
    staticClass: "modal-backdrop"
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "max-width": "800px",
      "height": "max-content"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "20px",
      "max-height": "400px",
      "overflow-y": "auto"
    }
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "margin-bottom-10px"
    }, [(_vm.showCountryPicker) ? [_c('label', {
      staticClass: "required"
    }, [_vm._v("Country")]), _vm._v(" "), _c('nv-select', {
      staticClass: "form-control",
      staticStyle: {
        "display": "inline-block",
        "min-width": "180px",
        "vertical-align": "middle",
        "margin-left": "8px"
      },
      on: {
        "change": function($event) {
          return _vm.onTurnCountryChange()
        }
      },
      model: {
        value: (_vm.turnCountry),
        callback: function($$v) {
          _vm.turnCountry = $$v
        },
        expression: "turnCountry"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("-- Select Country --")]), _vm._v(" "), _vm._l((_vm.turnCountryList), function(country) {
      return _c('option', {
        key: country,
        domProps: {
          "value": country
        }
      }, [_vm._v(_vm._s(country))])
    })], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "8px"
      }
    }, [_vm._v("Templates differ per country's Turn namespace. Select a country to load them.")])] : [_c('span', [_vm._v("Templates from "), _c('b', [_vm._v(_vm._s(_vm.turnCountry))])]), _vm._v(" "), (_vm.turnCountryList.length > 1) ? _c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.showCountryPicker = true
        }
      }
    }, [_vm._v("Change Country")]) : _vm._e()]], 2), _vm._v(" "), (_vm.turnCountry) ? _c('div', [_c('div', {
      staticClass: "nudge-origin-title"
    }, [_vm._v("WhatsApp Nudge(s):")]), _vm._v(" "), _vm._l((_vm.nudgePreviewData), function(data, index) {
      return _c('div', {
        key: index,
        staticClass: "margin-bottom-10px"
      }, [_c('span', {
        staticClass: "nudge-language"
      }, [_vm._v(_vm._s(data.language) + " :")]), _vm._v(" "), (data.turn_template_data && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(data.turn_template_data.HEADER_FORMAT)) ? _c('div', {
        staticStyle: {
          "max-width": "260px"
        }
      }, [_c('media-preview', {
        attrs: {
          "format": data.turn_template_data.HEADER_FORMAT,
          "media-id": data.media_id,
          "media-name": data.media_name || '',
          "file-name": data.media_file_name || '',
          "country-id": _vm.scheduleData.country || null,
          "language-id": data.language_id
        }
      })], 1) : _vm._e(), _vm._v(" "), (data.turn_template_data && data.turn_template_data.HEADER) ? _c('div', {
        staticClass: "nudge-whatsapp-header"
      }, [_vm._v(_vm._s(data.turn_template_data.HEADER))]) : _vm._e(), _vm._v(" "), (data.turn_template_data && data.turn_template_data.BODY) ? _c('div', {
        staticClass: "nudge-whatsapp-body"
      }, [_vm._v(_vm._s(data.turn_template_data.BODY))]) : _vm._e(), _vm._v(" "), (data.turn_template_data && data.turn_template_data.FOOTER) ? _c('div', {
        staticClass: "nudge-whatsapp-footer"
      }, [_vm._v(_vm._s(data.turn_template_data.FOOTER))]) : _vm._e(), _vm._v(" "), (data.turn_template_data && data.turn_template_data.BUTTONS) ? _c('div', {
        staticStyle: {
          "margin-top": "5px"
        }
      }, _vm._l((data.turn_template_data.BUTTONS), function(button, index) {
        return _c('span', {
          key: index,
          staticClass: "nudge-whatsapp-button"
        }, [_vm._v(_vm._s(button))])
      }), 0) : _vm._e(), _vm._v(" "), (!data.turn_template_data) ? _c('div', {
        staticClass: "nudge-whatsapp-body"
      }, [_vm._v(" -- Not available in " + _vm._s(_vm.turnCountry) + " -- ")]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      staticClass: "nudge-origin-title",
      staticStyle: {
        "margin-top": "15px"
      }
    }, [_vm._v("Facebook Nudge(s):")]), _vm._v(" "), _vm._l((_vm.nudgePreviewData), function(data, index) {
      return _c('div', {
        key: index,
        staticClass: "margin-bottom-10px"
      }, [_c('span', {
        staticClass: "nudge-language"
      }, [_vm._v(_vm._s(data.language) + " :")]), _vm._v(" "), (data.fb_nudge_text) ? _c('div', {
        staticClass: "nudge-whatsapp-body"
      }, [_vm._v(_vm._s(data.fb_nudge_text))]) : _c('div', {
        staticClass: "nudge-whatsapp-body"
      }, [_vm._v(" -- No data available -- ")])])
    })], 2) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeNudgePreview
    }
  }, [_vm._v("Close")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Step 1 | Reengagement Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "title": "Please check if users are added manually"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle margin-10"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Step 2 | Select Audience")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Step 4 | Deployment")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-9df1aa62","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reengagement-manager/createOrUpdateReengagement.vue
// module id = zMlT
// module chunks = 1